export const DART_RIGHT = 'DART_RIGHT';
export const DART_APEX = 'DART_APEX';
export const DART_LEFT = 'DART_LEFT';
export const DART_PIVOT = 'DART_PIVOT';
export const MIRROR_START = 'MIRROR_START';
export const MIRROR_END = 'MIRROR_END';
